// extracted by mini-css-extract-plugin
module.exports = {"mainLoad":"loader_mainLoad__1OhOB","loader":"loader_loader__ccUqK","animatedTitle":"loader_animatedTitle__Up90E","loadingText":"loader_loadingText__1HMSO"};